import { ReactElement, useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { useTranslation } from 'react-i18next';
import { GiveawayContext } from '@/state/state';
import { SunIcon } from '@/common/icons/Sun';
import { MoonIcon } from '@/common/icons/Moon';
import { ImageGallery } from '../gallery/gallery';
import { GALLERY_DATA } from '../clusterButton/ClusterButton.types';
import { CLUSTER_BUTTON_TYPES } from '@/enums/ClusterButton';

export const Exterior = (): ReactElement | null => {
  const giveawayData: GiveawayResponse = useContext(GiveawayContext);
  const assetDay = getGiveawayAssets(giveawayData, 'exterior');
  const assetNight = getGiveawayAssets(giveawayData, 'exterior-night');
  const assets = [...assetDay, ...assetNight];
  const { t } = useTranslation();

  if (!assetDay?.length) {
    return null;
  }

  const tabData: GALLERY_DATA[] = [
    {
      name: CLUSTER_BUTTON_TYPES.DAY,
      icon: <SunIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.dayImagesAriaLabel'),
      images: assetDay,
    },
    {
      name: CLUSTER_BUTTON_TYPES.NIGHT,
      icon: <MoonIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.nightImagesAriaLabel'),
      images: assetNight,
    },
  ];

  /*
   We need to pass all the assets here, because assetNight can be undefined,
   because older DGAs might not have them yet. This check can become irrelevant
   around ~June 2025

   This check further resolves the rendering issue of the VWN Transporter.
   In the orderservice we didn't adjust this render job for night images.
   So if the transporter issue persists in the future, we might still need this.

   Affected motor codes of transporter:
   'TVD', 'TVN', 'TVK', 'TVE', 'TVL', 'TVM', 'TWK', 'TWL', 'TWM', 'TWN'
  */
  return (
    <ImageGallery
      displayTabs={assetNight.length > 0}
      assets={assets}
      tabData={assetNight.length > 0 ? tabData : undefined}
      labelPrefix="Exterior"
      name={CLUSTER_BUTTON_TYPES.EXTERIOR}
      displaySubTitle
    />
  );
};
